import { batch, connect } from 'react-redux';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';

import { SlimFilterMenu } from 'src/components/organisms/FilterMenu/components/SlimFilterMenu/SlimFilterMenu';
import type {
  SlimFilterMenuContainerDispatchProps,
  SlimFilterMenuContainerStateProps,
} from 'src/components/organisms/FilterMenu/types';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import {
  selectActiveSortOption,
  selectAppliedFilterIDs,
  selectTotalActiveOptions,
} from 'src/redux/filter/selectors/selectors';
import { actions } from 'src/redux/filter/slice';
import { updateFilters, UpdateFiltersActionType } from 'src/redux/products/thunks/updateFilters';
import type { AppThunkDispatch } from 'src/redux/store';

const mapDispatchToProps = (dispatch: AppThunkDispatch): SlimFilterMenuContainerDispatchProps => ({
  onVisible: () => {
    sendGAEvent({
      event: 'custom_event',
      event_action: 'filter & sort sticky impression',
      event_category: 'Filter & sort',
      event_label: 'icon',
    });
  },
  openFilterModal: ({ totalNumberOfActiveOptions, totalNumberOfFiltersApplied }) => {
    sendGAEvent({
      event: 'custom_event',
      event_category: 'Filters',
      event_action: 'open modal',
      event_label: `number of categories: ${totalNumberOfFiltersApplied}|number of filters: ${totalNumberOfActiveOptions}`,
    });
    dispatch(actions.openModal());
  },
  onResetFilters: ({ totalNumberOfActiveOptions, totalNumberOfFiltersApplied }) => {
    batch(() => {
      dispatch(actions.resetFilters());
      dispatch(actions.resetSortOptions());
      dispatch(updateFilters(UpdateFiltersActionType.FILTER));
    });
    sendGAEvent({
      event: 'custom_event',
      event_category: 'Filters',
      event_action: 'reset all filters',
      event_label: `number of categories: ${totalNumberOfFiltersApplied}|number of filters: ${totalNumberOfActiveOptions}`,
    });
  },
});

const mapStateToProps = (state: ReduxApplicationState): SlimFilterMenuContainerStateProps => ({
  activeSortOption: selectActiveSortOption(state),
  totalNumberOfFiltersApplied: selectAppliedFilterIDs(state).length,
  totalNumberOfActiveOptions: selectTotalActiveOptions(state),
  totalProducts: state.products.totalProducts,
  pageProductsCount: state.products.productsReturnedCount,
});

export const SlimFilterMenuContainer = connect(mapStateToProps, mapDispatchToProps)(SlimFilterMenu);
